/* eslint-disable @typescript-eslint/no-explicit-any */
export default function SlotTime(props: { slots: any; selectedSlot: any; setSelectedSlot: any }): JSX.Element {
    const { slots, selectedSlot, setSelectedSlot } = props;
    console.log({ slots });
    return (
        <>
            <div className={`flex-col`} role="SlotTime">
                <div className="container  mx-auto justify-left items-center">
                    <div
                        className={`grid  grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 text-left  items-center`}
                    >
                        {slots &&
                            slots.length > 0 &&
                            slots.map((item, index) => {
                                return (
                                    <div className=" md:px-1 p-1" key={`slot-${index}`}>
                                        <div
                                            onClick={() => {
                                                setSelectedSlot(item.id);
                                            }}
                                            className={` flex rounded-lg items-center h-12 justify-center
                                             content-center border shadow-lg text-sm 
                                             border-sm-rent cursor-pointer
                                             ${
                                                 selectedSlot && selectedSlot === item.id
                                                     ? 'bg-sm-rent text-white'
                                                     : !item.available
                                                     ? 'bg-sm-gray text-black'
                                                     : 'hover:bg-sm-integrate hover:text-white bg-white text-black'
                                             }`}
                                        >
                                            {item.start && item.start}
                                            {' - '}
                                            {item.end && item.end}
                                            {!item.available && (
                                                <div className="absolute">
                                                    <div
                                                        className={`${
                                                            selectedSlot && selectedSlot === item.id
                                                                ? 'text-red-200'
                                                                : 'text-gray-600'
                                                        } flex-col pt-8 pb-1 text-xs'`}
                                                    >
                                                        No disponible
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </div>
        </>
    );
}
